const PAGE_SIZE_OPTIONS = [10, 20, 50] as const;
const MAX_PAGE_SIZE_OPTION = PAGE_SIZE_OPTIONS[PAGE_SIZE_OPTIONS.length - 1];

/** Page size options: 10/20/50 (≤ total) and total only when total ≤ 50. */
export const getPageSizeOptions = (total: number): number[] => {
  const options = new Set<number>();

  for (const size of PAGE_SIZE_OPTIONS) {
    if (size <= total) {
      options.add(size);
    }
  }

  if (total > 0 && total <= MAX_PAGE_SIZE_OPTION) {
    options.add(total);
  }

  return [...options].sort((a, b) => a - b);
};
